export enum VEHICLE_CONDITION {
  All = 'all',
  Used = 'used',
}
